export function adjustedCurrentBalance(rawBalance, credit) {
  const raw = Number(rawBalance);
  const base = Number.isFinite(raw) ? raw : 0;
  return Math.round((base - (Number(credit) || 0)) * 100) / 100;
}
